module.exports = __webpack_public_path__ + "img/surveyEmoji2.ca32d8c2.svg";